import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import Crumbs from "./Crumbs";

const Page = ({ children, title, actions, showHeader = true }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxWidth: "xl",
        mx: "auto",
        // width: "100%",
        px: { xs: 1, sm: 2 },
        // pb: { xs: 1, sm: 4 },
      }}
    >
      {showHeader && (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Crumbs />
          </Box>

          {/* PAGE HEADER */}
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              mb: 2,
              flexShrink: 0,
            }}
          >
            <Grid item>
              <Typography variant="h5" component="h1" fontWeight="bold">
                {title}
              </Typography>
            </Grid>

            {actions && <Grid item>{actions}</Grid>}
          </Grid>
        </>
      )}

      <Box
        sx={{
          // flex: 1, // Makes this Box take up all available space
          // overflowY: "auto", // Enables vertical scrolling for the content
          // p: 3,
          // backgroundColor: "background.paper",
          borderRadius: 4,
          // boxShadow: 1,
          // border: `1px solid ${theme.palette.divider}`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Page;
